/* eslint-disable jsx-a11y/iframe-has-title */
import React from 'react'


const Location = () => {
  return (
    <div>
        <p className='w-full h-full flex justify-center items-center mt-50' >
        <iframe className='mt-100'  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3825.5522004595223!2d80.6412220154434!3d16.498197032179643!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3a35fb7feeb7a797%3A0x63b374b3262940aa!2sVishnu%20Paradise!5e0!3m2!1sen!2sin!4v1680537470218!5m2!1sen!2sin" width="800" height="600" style={{border:0}} allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe></p>
        </div>


  )
}

export default Location